import React, { useState } from "react";

export default function AgriLinkContractFarmingForm() {
  const [farmName, setFarmName] = useState("");
  const [farmType, setFarmType] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [village, setVillage] = useState("");
  const [stateDistrict, setStateDistrict] = useState("");
  const [cropType, setCropType] = useState("");
  const [cropName, setCropName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [harvestDate, setHarvestDate] = useState("");
  const [organic, setOrganic] = useState("");
  const [certifications, setCertifications] = useState([]);
  const [price, setPrice] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [packaging, setPackaging] = useState("");
  const [minOrder, setMinOrder] = useState("");
  const [longTerm, setLongTerm] = useState("");
  const [notes, setNotes] = useState("");
  const [showAbout, setShowAbout] = useState(false);

  const farmTypes = ["Farmer", "Nursery", "Agri-Business", "Cooperative"];
  const cropTypes = ["Vegetables", "Fruits", "Spices", "Herbs", "Grains", "Others"];
  const deliveryOptions = ["Farm Pickup", "Buyer Pickup", "Marketplace", "Cold Storage Delivery"];
  const certOptions = ["Organic", "FPO", "Govt Quality Cert", "Other"];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!cropType || !cropName || !quantity || !farmName || !pinCode) {
      alert("Please fill all required fields (Farm Name, Crop Type, Crop Name, Quantity, PIN).");
      return;
    }

    alert(`Contract Farming Lead Submitted:
Farm Name: ${farmName}
Farm Type: ${farmType}
PIN: ${pinCode}
Village: ${village}
State/District: ${stateDistrict}
Crop Type: ${cropType}
Crop Name: ${cropName}
Quantity: ${quantity}
Harvest Date: ${harvestDate}
Organic: ${organic}
Certifications: ${certifications.join(", ")}
Price Expectation: ${price}
Delivery Type: ${deliveryType}
Packaging: ${packaging}
Minimum Order: ${minOrder}
Long Term Contract: ${longTerm}
Notes: ${notes}`);
  };

  const handleCertificationChange = (cert) => {
    setCertifications((prev) =>
      prev.includes(cert) ? prev.filter((c) => c !== cert) : [...prev, cert]
    );
  };

  return (
    <div className="mx-auto p-6 bg-black shadow-lg rounded-2xl relative items-center">
      <h2 className="text-xl font-bold mb-4 text-white">Contract Farming Lead Form</h2>

      {/* About Button */}
      <button
        type="button"
        onClick={() => setShowAbout(true)}
        className="mb-4 bg-purple-600 w-64 text-white px-4 py-2 rounded hover:bg-purple-700"
      >
        About Contract Farming
      </button>

      {/* About Modal */}
      {showAbout && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-black border border-green-500 p-6 rounded-2xl max-w-2xl shadow-xl overflow-y-auto max-h-[80vh]">
            <h3 className="text-2xl font-bold mb-4 text-center text-yellow-100">
              About Contract Farming
            </h3>
            <div className="space-y-4 text-white text-sm leading-relaxed">
              <p>
                Contract farming allows farmers, nurseries, and agri-businesses to offer crops to
                buyers under agreed terms. It ensures better market access, transparent pricing,
                and predictable demand for both parties.
              </p>
              <p>
                <b>AgriLink Contract Farming Module</b> helps farmers submit leads, negotiate terms,
                and get connected with verified buyers efficiently.
              </p>
            </div>
            <div className="mt-6 text-center">
              <button
                onClick={() => setShowAbout(false)}
                className="bg-red-600 text-white px-4 py-2 w-24 rounded hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 lg:max-w-4xl text-white">
        {/* Farm Name & Type */}
        <div>
          <label className="block font-medium mb-1">Farm / Supplier Name *</label>
          <input
            type="text"
            value={farmName}
            onChange={(e) => setFarmName(e.target.value)}
            placeholder="Enter farm or supplier name"
            style={{width: "100%"}}
            className="h-10 w-full border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Type</label>
          <select
            value={farmType}
            onChange={(e) => setFarmType(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Choose Type --</option>
            {farmTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        {/* Location */}
        <div>
          <label className="block font-medium mb-1">PIN Code *</label>
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Village / Area</label>
          <input
            type="text"
            value={village}
            onChange={(e) => setVillage(e.target.value)}
            placeholder="Enter village or area"
            className="w-full border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">State / District</label>
          <input
            type="text"
            value={stateDistrict}
            onChange={(e) => setStateDistrict(e.target.value)}
            placeholder="Enter state or district"
            className="w-full border p-2 rounded text-black"
          />
        </div>

        {/* Crop Details */}
        <div>
          <label className="block font-medium mb-1">Crop Type *</label>
          <select
            value={cropType}
            onChange={(e) => setCropType(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Choose Crop Type --</option>
            {cropTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block font-medium mb-1">Crop Name / Variety *</label>
          <input
            type="text"
            value={cropName}
            onChange={(e) => setCropName(e.target.value)}
            placeholder="Enter crop name or variety"
            className="h-10 w-full border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Expected Quantity / Acreage *</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="Enter expected quantity or acreage"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Expected Harvest Date</label>
          <input
            type="month"
            value={harvestDate}
            onChange={(e) => setHarvestDate(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          />
        </div>

        {/* Organic & Certifications */}
        <div>
          <label className="block font-medium mb-1">Organic / Conventional</label>
          <select
            value={organic}
            onChange={(e) => setOrganic(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Select --</option>
            <option value="Organic">Organic</option>
            <option value="Conventional">Conventional</option>
          </select>
        </div>
        <div>
          <label className="block font-medium mb-1">Certifications</label>
          <div className="flex flex-wrap gap-2">
            {certOptions.map((cert) => (
              <label key={cert} className="bg-gray-300 px-2 py-1 rounded text-black cursor-pointer">
                <input
                  type="checkbox"
                  checked={certifications.includes(cert)}
                  onChange={() => handleCertificationChange(cert)}
                  className="mr-1"
                />
                {cert}
              </label>
            ))}
          </div>
        </div>

        {/* Price & Delivery */}
        <div>
          <label className="block font-medium mb-1">Price Expectation (optional)</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price per kg / ton (optional)"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Preferred Delivery Type</label>
          <select
            value={deliveryType}
            onChange={(e) => setDeliveryType(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Choose Delivery Type --</option>
            {deliveryOptions.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block font-medium mb-1">Packaging Type</label>
          <input
            type="text"
            value={packaging}
            onChange={(e) => setPackaging(e.target.value)}
            placeholder="Bulk / Retail / Custom"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Minimum Order Quantity</label>
          <input
            type="number"
            value={minOrder}
            onChange={(e) => setMinOrder(e.target.value)}
            placeholder="Enter minimum order quantity"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Interested in Long-Term Contract</label>
          <select
            value={longTerm}
            onChange={(e) => setLongTerm(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

        {/* Notes */}
        <div>
          <label className="block font-medium mb-1">Notes / Special Requirements</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Enter any additional information"
            style={{height: "300px", width: "100%"}}
            className="w-full border p-2 rounded bg-gray-200 text-black"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-green-600 text-white w-20 px-4 py-2 rounded hover:bg-green-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
}
